import * as React from "react";
import {useTheme} from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import PrintIcon from "@mui/icons-material/Print";
import {
  Alert,
  Card,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Snackbar,
  TextField,
  Tooltip
} from "@mui/material";
import MDButton from "components/MDButton";
import dayjs from "dayjs";
import Paper from "@mui/material/Paper";
import {DataGrid, GridActionsCellItem} from "@mui/x-data-grid";
import {GET} from "APIclient";
import {useEffect, useState} from "react";
import {toast} from "react-toastify";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MDInput from "components/MDInput";
import {useMaterialUIController} from "context";
import {POST} from "APIclient";
import {useLocation, useNavigate} from "react-router-dom";
import properties from "constants/ApplicationConstants";
import axios from "axios";
import {BASE_URL} from "APIclient";
import {formatDesignation} from "constants/ApplicationConstants";
import {formatDate} from "constants/ApplicationConstants";

const rows = [{id: 1, issuedBy: "kiran", reason: "test", issuedOn: "15 Jul 2021"}];

export default function AddressCertificate(noGutter) {
  const empId = window.sessionStorage.getItem("empId");
  const theme = useTheme();
  const [controller] = useMaterialUIController();
  const {darkMode} = controller;
  const location = useLocation();
  const [usersState, setUsersState] = useState(location.state);
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [snackbar, setSnackbar] = React.useState(null);
  const [snakColor, setSnakColor] = React.useState("");
  const [snakMessage, setSnakMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("error");
  const [details, setDetails] = useState([]);
  const fetchUrl = `admin/employee/get-address-certificate/${usersState}`;
  const viewUrl = `admin/get-salaries/${usersState}`;
  const [data, setData] = useState([]);
  const [hrManager, setHrManager] = useState([]);
  const [isFormValid, setIsFormValid] = useState(false);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    reason: "",
    issuedBy: "",
    permanentAddress: 0,
    presentAddress: 0
  });

  const [errors, setErrors] = useState({
    reason: "",
    issuedBy: "",
    address: ""
  });

  const validateField = (name, value, formData) => {
    let tempErrors = {...errors};

    if (name === "reason") {
      if (!value || value.trim().length < 5) {
        tempErrors.reason = "Reason is required (min 5 characters)";
      } else if (/[^a-zA-Z\s]/.test(value)) {
        tempErrors.reason = "Reason should not contain numbers or special characters";
      } else {
        tempErrors.reason = "";
      }
    }

    if (name === "issuedBy") {
      if (!value) {
        tempErrors.issuedBy = "Please select the HR Manager";
      } else {
        tempErrors.issuedBy = "";
      }
    }

    if (name === "permanentAddress" || name === "presentAddress") {
      const {permanentAddress, presentAddress} = formData;
      if (permanentAddress === 0 && presentAddress === 0) {
        tempErrors.address = "Select at least one address";
      } else {
        tempErrors.address = "";
      }
    }

    return tempErrors;
  };

  const validateForm = () => {
    let tempErrors = {
      reason: "",
      issuedBy: "",
      address: ""
    };
    let isValid = true;

    if (!formData.reason || formData.reason.trim().length < 5) {
      tempErrors.reason = "Reason is required (min 5 characters)";
      isValid = false;
    }

    if (!formData.issuedBy) {
      tempErrors.issuedBy = "Please select the HR Manager";
      isValid = false;
    }

    if (formData.permanentAddress === 0 && formData.presentAddress === 0) {
      tempErrors.address = "Select at least one address";
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await GET(fetchUrl);
        const data = response?.data?.data;
        setData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
    const view = async () => {
      try {
        const response = await GET(viewUrl);
        if (response?.status === 200) {
          const view = response?.data?.data;
          const formattedView = {
            ...view,
            designation: formatDesignation(view?.designation)
          };
          setDetails(formattedView);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    view();
  }, [fetchUrl, viewUrl]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleView = () => () => {
    window.print();
  };

  const handleChange = event => {
    const {name, value} = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));

    const updatedFormData = {...formData, [name]: value};
    const updatedErrors = validateField(name, value, updatedFormData);
    setErrors(updatedErrors);
  };
  const handleChecked = event => {
    const {name, checked} = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: checked == true ? 1 : 0
    }));

    const updatedFormData = {
      ...formData,
      [name]: checked ? 1 : 0
    };
    const updatedErrors = validateField(name, checked ? 1 : 0, updatedFormData);
    setErrors(updatedErrors);
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    const dt = {
      reason: formData.reason,
      issuedBy: parseInt(formData.issuedBy),
      permanentAddress: formData.permanentAddress,
      presentAddress: formData.presentAddress
    };

    const url = `admin/employee/address-certificate/${usersState}`;

    try {
      const response = await POST(url, dt);
      if (response?.data?.statusCode === 200) {
        setSnakColor("success");
        setSnakMessage("Salary Revision updated successfully");
        setOpen(true);
        // navigate('/some/other/page');
        try {
          const response = await GET(fetchUrl);
          const data = response?.data?.data;
          if (response?.data?.statusCode === 200) {
            setData(data);
          } else {
            setSnakColor("error");
            setSnakMessage(response?.data?.message);
            setOpen(true);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      } else {
        setSnakColor("error");
        setSnakMessage("Failed to update Salary Revision");
        setOpen(true);
      }
    } catch (error) {
      console.error("Error updating Salary Revision:", error);
      setSnakColor("error");
      setSnakMessage("Error updating Salary Revision");
      setOpen(true);
    }
  };

  React.useEffect(() => {
    const getUrl = `admin/hr-managers`;
    const getHrManager = async () => {
      try {
        const response = await GET(getUrl);
        const data = response?.data?.data;
        setHrManager(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    getHrManager();
  }, []);

  useEffect(() => {
    const isValid =
      formData.reason.trim().length >= 5 &&
      !!formData.issuedBy &&
      (formData.permanentAddress === 1 || formData.presentAddress === 1);
    setIsFormValid(isValid);
  }, [formData]);

  const columns = [
    {field: "empCertificateId", headerName: "#", width: 30},
    {field: "issuedBy", headerName: "Issued By", width: 150},
    {field: "reason", headerName: "Reason", width: 150},

    // {field: "TotalDays", headerName: "TotalDays", type: "number", width: 90},
    {
      field: "issuedOn",
      headerName: "Issued On",
      width: 150,
      renderCell: params => {
        const formattedDate = formatDate(params.value);
        return formattedDate || "N/A";
      }
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 80,
      renderCell: params => [
        <GridActionsCellItem
          key={`print-${params.row.empCertificateId}`}
          icon={
            <Tooltip title="Print Address Certificate" arrow>
              <PrintIcon />
            </Tooltip>
          }
          label="Print"
          color="success"
          onClick={() => handlePrintAddressLetter(params.row)}
        />
      ]
    }
  ];

  const handlePrintAddressLetter = async row => {
    try {
      const url = `${BASE_URL}/admin/employee/downloadCertificate?type=address_letter&search=${row.empCertificateId}`;

      const response = await axios.get(url, {
        headers: {
          Accept: "application/pdf",
          Authorization: `Bearer ${window.sessionStorage.getItem("jwtToken")}`
        },
        responseType: "blob",
        withCredentials: true
      });

      if (response.status !== 200) {
        throw new Error("Failed to fetch the address letter PDF");
      }

      const fileBlob = new Blob([response.data], {type: "application/pdf"});

      const fileUrl = URL.createObjectURL(fileBlob);

      const newWindow = window.open(fileUrl, "_blank");

      if (!newWindow) {
        alert("Please allow pop-ups to view the appointment letter.");
      }
    } catch (error) {
      console.error("Error fetching appointment letter:", error);
      alert("Error generating the appointment letter. Please try again.");
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox>
        <AppBar position="static">
          <MDBox pt={4} pb={3} px={0}>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <Card container>
                  <MDTypography
                    p={2}
                    variant="h6"
                    fontWeight="bold"
                    pb={2}
                    sx={{fontFamily: properties.fontFamily}}
                  >
                    Add Address Certificate
                  </MDTypography>
                  <MDBox pt={0} alignItems="center">
                    <MDInput
                      sx={{m: 1, width: "20ch"}}
                      multiline
                      maxRows={4}
                      type="text"
                      name="reason"
                      value={formData?.reason}
                      onChange={e => handleChange(e)}
                      label={
                        <span>
                          Reason <span style={{color: properties.colors.Red}}>*</span>
                        </span>
                      }
                      variant="standard"
                      error={!!errors.reason}
                      helperText={errors.reason}
                    />
                  </MDBox>
                  <MDBox pt={2}>
                    <FormControl variant="standard" sx={{m: 1, width: "20ch"}}>
                      <InputLabel id="issuedBy" sx={{fontWeight: "bold"}}>
                        Issued By <span style={{color: properties.colors.Red}}>*</span>
                      </InputLabel>
                      <Select
                        pb={4}
                        labelId="issuedBy"
                        id="issuedBy"
                        value={parseInt(formData?.issuedBy)}
                        name="issuedBy"
                        onChange={e => handleChange(e)}
                        label="issued By"
                        required
                      >
                        <MenuItem value="">
                          <em>Select Location</em>
                        </MenuItem>
                        {hrManager?.map(manager => (
                          <MenuItem key={manager.empId} value={manager.empId}>
                            {`${manager.firstName} ${manager.lastName}`}
                          </MenuItem>
                        ))}
                      </Select>
                      {errors.issuedBy && (
                        <span style={{color: "red", fontSize: "12px", marginLeft: "14px"}}>
                          {errors.issuedBy}
                        </span>
                      )}
                    </FormControl>
                  </MDBox>
                  <MDBox p={2}>
                    <FormGroup>
                      <FormControlLabel
                        name="permanentAddress"
                        onChange={e => handleChecked(e)}
                        control={<Checkbox />}
                        label="Permanent Address"
                        sx={{
                          "& .MuiFormControlLabel-label": {
                            fontFamily: properties.fontFamily,
                            fontSize: "14px"
                          }
                        }}
                      />
                      <FormControlLabel
                        name="presentAddress"
                        onChange={e => handleChecked(e)}
                        control={<Checkbox />}
                        label="Present Address"
                        sx={{
                          "& .MuiFormControlLabel-label": {
                            fontFamily: properties.fontFamily,
                            fontSize: "14px"
                          }
                        }}
                      />
                      {errors.address && (
                        <span style={{color: "red", fontSize: "12px", marginLeft: "14px"}}>
                          {errors.address}
                        </span>
                      )}
                    </FormGroup>
                  </MDBox>
                  <MDBox pt={2}></MDBox>
                  <MDBox mt={3} mb={2} sx={{display: "flex", justifyContent: "flex-end"}}>
                    <MDBox sx={{display: "flex", gap: 1}}>
                      <MDButton
                        variant="gradient"
                        color="warning"
                        sx={{marginRight: "10px", width: "12ch", fontFamily: properties.fontFamily}}
                        onClick={() => navigate(-1)}
                      >
                        Back
                      </MDButton>
                      <MDButton
                        variant="gradient"
                        color="info"
                        sx={{
                          width: "12ch",
                          mr: 1,
                          background: properties.colors.bgcolorbluethem,
                          fontFamily: properties.fontFamily
                        }}
                        onClick={handleSubmit}
                        disabled={!isFormValid}
                      >
                        Add
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </Card>
                <Snackbar
                  open={open}
                  anchorOrigin={{vertical: "top", horizontal: "right"}}
                  autoHideDuration={1200}
                  onClose={handleClose}
                >
                  <Alert
                    onClose={handleClose}
                    close={handleClose}
                    severity={snakColor == "success" ? "success" : "error"}
                    variant="filled"
                    sx={{width: "100%"}}
                  >
                    {snakMessage}
                  </Alert>
                </Snackbar>
              </Grid>
              <Grid item xs={8}>
                <Card container>
                  <MDBox p={2}>
                    <MDTypography
                      variant="h6"
                      fontWeight="bold"
                      pb={1}
                      sx={{fontFamily: properties.fontFamily}}
                    >
                      Employee Details
                    </MDTypography>
                  </MDBox>
                  <MDBox pb={2} px={3}>
                    <MDBox
                      component="li"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="flex-start"
                      bgColor={darkMode ? "transparent" : "grey-100"}
                      borderRadius="lg"
                      p={2}
                      mt={1}
                    >
                      <MDBox width="100%" display="flex" flexDirection="column">
                        <MDBox
                          display="grid"
                          gridTemplateColumns={{xs: "1fr", sm: "repeat(2, 1fr)"}}
                          gap={2}
                          mb={2}
                        >
                          <MDBox display="flex" alignItems="center">
                            <MDTypography
                              variant="caption"
                              color="text"
                              fontFamily={properties.fontFamily}
                              sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                            >
                              Employee ID:
                            </MDTypography>
                            <MDTypography
                              variant="caption"
                              fontFamily={properties.fontFamily}
                              sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                            >
                              {details ? details.empId : "-"}
                            </MDTypography>
                          </MDBox>
                          <MDBox display="flex" alignItems="center">
                            <MDTypography
                              variant="caption"
                              color="text"
                              fontFamily={properties.fontFamily}
                              sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                            >
                              Username:
                            </MDTypography>
                            <MDTypography
                              variant="caption"
                              fontFamily={properties.fontFamily}
                              sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                            >
                              {details
                                ? `${details.firstName || ""} ${details.lastName || ""}`.trim()
                                : "-"}
                            </MDTypography>
                          </MDBox>
                          <MDBox display="flex" alignItems="center">
                            <MDTypography
                              variant="caption"
                              color="text"
                              fontFamily={properties.fontFamily}
                              sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                            >
                              Joining Date:
                            </MDTypography>
                            <MDTypography
                              variant="caption"
                              fontFamily={properties.fontFamily}
                              sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                            >
                              {details ? formatDate(details.joinDate) : "-"}
                            </MDTypography>
                          </MDBox>
                          <MDBox display="flex" alignItems="center">
                            <MDTypography
                              variant="caption"
                              color="text"
                              fontFamily={properties.fontFamily}
                              sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                            >
                              Designation:
                            </MDTypography>
                            <MDTypography
                              variant="caption"
                              fontFamily={properties.fontFamily}
                              sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                            >
                              {details ? formatDesignation(details.designation) : "-"}
                            </MDTypography>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                    <MDTypography
                      variant="h6"
                      fontWeight="bold"
                      pt={2}
                      pb={2}
                      sx={{fontFamily: properties.fontFamily}}
                    >
                      Address Certificate Details
                    </MDTypography>

                    <Paper sx={{width: "100%", overflow: "auto"}}>
                      <DataGrid
                        rows={data}
                        columns={columns}
                        getRowId={row => row.empCertificateId}
                        size="small"
                        aria-label="a dense table"
                        pagination={false}
                        hideFooter={rows.length <= 20}
                        hideFooterPagination={true}
                        sx={{
                          fontFamily: properties.fontFamily,
                          fontSize: "14px",
                          "& .MuiDataGrid-columnHeaders": {
                            position: "sticky",
                            top: 0,
                            backgroundColor: "white",
                            zIndex: 1000
                          },
                          "& .MuiDataGrid-virtualScroller": {
                            overflow: "auto"
                          },
                          "& .MuiDataGrid-root": {
                            height: "auto",
                            maxHeight: "600px"
                          }
                        }}
                      />
                    </Paper>
                  </MDBox>
                </Card>
              </Grid>
            </Grid>
          </MDBox>
        </AppBar>
      </MDBox>
    </DashboardLayout>
  );
}
